var render = function render(){var _vm=this,_c=_vm._self._c;return _c('account-signup',{attrs:{"platform":"portal","entityLevel":_vm.entityLevel,"entityName":_vm.entityName}})
}
var staticRenderFns = []

export { render, staticRenderFns }